var file_upload_viewer_default = {
  "fontElementMap": "_8n45x",
  "file_upload_container": "MEVRT",
  "file_upload_link": "ls2S4",
  "file_upload_error_container": "_7NlNP",
  "file_upload_file_info": "_4wPsl",
  "file_upload_type_icon": "ggPGJ",
  "file_upload_status_icon_container": "qMixj",
  "file_upload_status_icon": "cAuV4",
  "file_upload_description": "HIMPS",
  "file_upload_name_container": "_6ddFc",
  "file_upload_name": "hIMZo",
  "file_upload_extension": "UuE3e",
  "file_loader_icon": "_8UKOV",
  "file_upload_icon_frame": "V8G9N",
  "file_upload_icon_background": "x2CU4"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
